import { useTranslation } from '@crehana/i18n';

import { B2B_CHECKOUT_PAGE_KEY } from '../constants';
import locales, { type TKeys } from '../i18n';

export function useCheckoutTranslation() {
  const { addResourceBundle, t } = useTranslation<TKeys>(B2B_CHECKOUT_PAGE_KEY);

  addResourceBundle(locales, { injectOnce: true });

  return { t };
}

export default useCheckoutTranslation;
